import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../App/hooks";
import { ITableUI } from "../../TableTemplate/tableTemplate";
import { setManualOrderTableFetchDataFlag } from "../../../Features/Manual/manualSlice";
import { CommonTableUI } from "../../TableTemplate/common";
import { ManualOrderTableAdditional } from "./Additional";
import { IManualOrderTableReport } from "../../../Interfaces/manualInterfaces";

const TableUI: React.FC<ITableUI<IManualOrderTableReport>> = ({
  reports,
  onAction,
  onTableHeaderClick,
  onTableRowClick,
  sortingType,
  setSortingType,
}: ITableUI<IManualOrderTableReport>) => {
  const dispatch = useAppDispatch();
  const orderTableFetchDataFlag = useAppSelector(
    (store) => store.manual.orderTableFetchDataFlag
  );

  useEffect(() => {
    if (!!orderTableFetchDataFlag && onAction) {
      dispatch(setManualOrderTableFetchDataFlag(false));
      onAction();
    }
  }, [dispatch, onAction, orderTableFetchDataFlag]);

  return (
    <CommonTableUI
      reports={reports}
      onAction={onAction}
      AdditionalBody={ManualOrderTableAdditional}
      withSelect
      onTableHeaderClick={onTableHeaderClick}
      onTableRowClick={onTableRowClick}
      sortingType={sortingType}
      tableBoxClassName="max-h-[500px] overflow-auto"
      setSortingType={setSortingType}
    />
  );
};

export default TableUI;
